import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-carte-controllers-gadget',
    imports: [CommonModule],
    templateUrl: './carte-controllers-gadget.component.html',
    styleUrl: './carte-controllers-gadget.component.scss'
})
export class CarteControllersGadgetComponent {

  @Input() selectedBtn:number = -1;
  @Output() btnOrtho= new EventEmitter<boolean>();
  @Output() btnBingMap = new EventEmitter<boolean>();
  @Output() btnZoom = new EventEmitter<number>();

clickBtnOrtho(){
  this.selectedBtn = 2;
  this.btnOrtho.emit(true);
}
clickBtnBingMap(){
  if (this.selectedBtn == 1) {
    this.selectedBtn = -1;
  }else{
    this.selectedBtn = 1;
  }
  this.btnBingMap.emit(true);

}
clickBtnZoom(zoom:number){
  this.btnZoom.emit(zoom);
}

}
